export const ApUpdateSpaceAdmins = Symbol('ApUpdateSpaceAdmins');
